export type InvoiceStatus = "Unpaid" | "Paid" | "Cancelled" | "Unposted";

export const InvoiceDateTypes = {
  INVOICE_DATE: "InvoiceDate",
  LAST_SETTLE_DATE: "LastSettleDate",
  ORDER_DATE: "OrderDate",
} as const;

export type InvoiceDateType = (typeof InvoiceDateTypes)[keyof typeof InvoiceDateTypes];

export interface PurchaseOrderInvoice {
  invoiceId: string;
  invoiceDate: string;
  invoiceAmount: number;
  invoiceStatus: InvoiceStatus;
  poCount: number;
  lastSettleDate: string;
  dueDate: string;
  currencyCode: string;
  invoiceLines: PurchaseOrderInvoiceLines[];
}

export interface InvoiceStats {
  toBePaidAmount: number;
  unPostedAmount: number;
  currencySymbol: string;
}

export interface PurchaseOrderInvoiceLines {
  purchaseOrderId: string;
  orderDate: string;
  shipDate: string;
  purchaseOrderStatus: string;
  orderAmount: number;
  shippingFee: number;
  vatRate?: number;
  vatAmount?: number;
  orderAmountBeforeTax?: number;
  ksAmount?: number;
  shipToCountry?: string;
  taxJurisdiction?: string;
}

export interface PurchaseOrderInvoiceLineDetails {
  invoiceId: string;
  invoiceDate: string;
  invoiceStatus: InvoiceStatus;
  shipDate: string;
  purchaseOrderId: string;
  approvedAmount: number;
  quantity: number;
  itemName: string;
  itemNumber: string;
}

export interface InvoiceDetailsRequest {
  vendorKey?: string;
  limit?: number;
  max?: number;
  lastInvoiceId?: string;
  startDate?: string;
  endDate?: string;
  dateType?: InvoiceDateType;
}
